'use client';

import { useState } from 'react';

import type { TaskStateFilter } from '@/lib/admin/client';
import { useTaskStatus } from '@/lib/query/useTaskStatus';

import { TaskOverview } from './TaskOverview';
import { TaskStatusPanel } from './TaskStatusPanel';

export function TaskTab() {
  const [stateFilter, setStateFilter] = useState<TaskStateFilter>('all');
  const status = useTaskStatus(null);
  const data = status.data?.status === 'available' ? status.data.data : null;

  return (
    <div className="space-y-6">
      <TaskOverview
        data={data}
        isLoading={status.isLoading}
        isError={status.isError}
        isDisabled={status.data?.status === 'disabled'}
        onStateFilterChange={setStateFilter}
      />
      <TaskStatusPanel
        overviewData={data}
        stateFilter={stateFilter}
        onStateFilterChange={setStateFilter}
      />
    </div>
  );
}
